import script from "./LoaderContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderContainer.vue?vue&type=script&setup=true&lang=js"

import "./LoaderContainer.vue?vue&type=style&index=0&id=ddde369c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddde369c"]])

export default __exports__